import { Configuration } from '@oncampusabroad/api';

export type Loading = "idle" | "pending" | "succeeded" | "failed";

export interface ApiCallBase {
  response: any;
  loading: Loading;
  error?: any;
}

export const initialApiState: ApiCallBase = {
  response: {},
  loading: "idle",
};


const HARDCODED_LOCAL_BASE_URL = 'https://dudgd9bdj5jbn.cloudfront.net';

const isLocalHostname = (hostname: string): boolean => {
  if (!hostname) return false;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === '0.0.0.0' || hostname.endsWith('.local');
};

const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location;

    if (isLocalHostname(hostname)) {
      return HARDCODED_LOCAL_BASE_URL;
    }

    if (hostname === 'd3q7bbp0fvmr11.cloudfront.net') {
      return HARDCODED_LOCAL_BASE_URL;
    }

    return origin;
  }
  
};

export const API_BASE_URL = getApiBaseUrl();
// export const API_BASE_URL = 'https://dudgd9bdj5jbn.cloudfront.net';

export const createApiConfiguration = (accessToken?: string): Configuration => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }

  return new Configuration({
    basePath: API_BASE_URL, 
    baseOptions: {
      headers,
    },
  });
}; 